(function () {
    "use strict";

    angular.module("app.general").factory("GeneralService", GeneralService);

    GeneralService.$inject = ["$http", "$q"];

    function GeneralService($http, $q) {
        var service = {
            getCountry: getCountry,
            getCountryOfSalesPoint: getCountryOfSalesPoint,
            getStateProvince: getStateProvince,
            getStateProvinceOfCountry: getStateProvinceOfCountry,
            getStateProvinceOfSalesPoint: getStateProvinceOfSalesPoint,
            getStateProvinceOfSalesPointWithoutCountry:
                getStateProvinceOfSalesPointWithoutCountry,
            getDistrict: getDistrict,
            getDistrictOfSalesPoint: getDistrictOfSalesPoint,
            getCity: getCity,
            getSalesPoints: getSalesPoints,
            getSalesPointsWithParameter: getSalesPointsWithParameter,
            getCurrentShipmentProvider: getCurrentShipmentProvider,
            GetCheckoutBanks: GetCheckoutBanks,
            GetBanks: GetBanks,
            GetDefaultCheckoutBank: GetDefaultCheckoutBank,
            getGalleryMediaList: getGalleryMediaList,
        };

        var serviceBase = "/";

        return service;

        function getCountry() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/Country")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getCountryOfSalesPoint() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/CountryOfSalesPoint")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getStateProvince() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/StateProvince")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getStateProvinceOfCountry(CountryId) {
            var deferred = $q.defer();

            $http
                .get(
                    serviceBase + "api/general/StateProvince" + "/" + CountryId
                )
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getStateProvinceOfSalesPoint(CountryId) {
            var deferred = $q.defer();

            $http
                .get(
                    serviceBase + "api/general/StateProvince" + "/" + CountryId
                )
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getStateProvinceOfSalesPointWithoutCountry() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/StateProvinceWithoutCountry")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getDistrict(StateProvinceId) {
            var deferred = $q.defer();

            $http
                .get(
                    serviceBase +
                        "api/general/district?StateProvinceId=" +
                        StateProvinceId
                )
                .then(getDistrictComplete)
                .catch(getDistrictFailed);

            function getDistrictComplete(response) {
                deferred.resolve(response);
            }

            function getDistrictFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getDistrictOfSalesPoint(StateProvinceId) {
            var deferred = $q.defer();

            $http
                .get(
                    serviceBase + "api/general/district" + "/" + StateProvinceId
                )
                .then(getDistrictComplete)
                .catch(getDistrictFailed);

            function getDistrictComplete(response) {
                deferred.resolve(response);
            }

            function getDistrictFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getCity(DistrictId) {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/city?DistrictId=" + DistrictId)
                .then(getCityComplete)
                .catch(getCityFailed);

            function getCityComplete(response) {
                deferred.resolve(response);
            }

            function getCityFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getSalesPoints() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/salespoint")
                .then(getCityComplete)
                .catch(getCityFailed);

            function getCityComplete(response) {
                deferred.resolve(response);
            }

            function getCityFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getSalesPointsWithParameter(DistrictId) {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/salespoint/" + DistrictId)
                .then(getCityComplete)
                .catch(getCityFailed);

            function getCityComplete(response) {
                deferred.resolve(response);
            }

            function getCityFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getCurrentShipmentProvider(ShipmentProviderId) {
            var deferred = $q.defer();

            $http
                .get(
                    serviceBase +
                        "api/general/shipmentprovider" +
                        "/" +
                        ShipmentProviderId
                )
                .then(getCurrentShipmentProviderComplete)
                .catch(getCurrentShipmentProviderFailed);

            function getCurrentShipmentProviderComplete(response) {
                deferred.resolve(response);
            }

            function getCurrentShipmentProviderFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function GetCheckoutBanks() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/banks/checkout")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function GetBanks() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/banks")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function GetDefaultCheckoutBank() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/banks/default")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getGalleryMediaList(filterModel) {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/general/GetGalleryMediaList", {
                    params: filterModel,
                })
                .then(getGalleryListComplete)
                .catch(getGalleryListFailed);

            function getGalleryListComplete(response) {
                deferred.resolve(response);
            }

            function getGalleryListFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();
